import { Routes } from '@angular/router';

export const STATUS_FARM_ROUTES: Routes = [
	{
		path: 'statusFarm',
		loadComponent: () => import('./feature-status-farm/status-farm').then((m) => m.StatusFarm),
		data: { title: 'Mapeamento' },
	},
];
